import styled from "@emotion/styled";

const Margin = styled.div<{ m: 4 | 8 | 12 | 16 | 24 | 32 | 64 }>`
  margin: ${(props) => props.m}px;
`;

export default Margin;
